import { createStyles } from 'antd-style';

const useStyles = createStyles(({ token, css }) => {
  return {
    viewRoot: css`
      display: flex;
      flex-direction: column;
      gap: ${token.marginXL}px;
    `,

    introAlert: css`
      .ant-alert-message {
        margin-bottom: 6px;
      }
    `,

    introList: css`
      margin: 0;
      padding-left: 18px;
      list-style: disc;

      li {
        line-height: 1.8;
        font-size: 13px;

        &::marker {
          color: ${token.colorTextTertiary};
        }
      }
    `,

    viewHeader: css`
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: ${token.padding}px;
      margin-bottom: ${token.marginLG}px;
    `,

    viewHeaderDesc: css`
      flex: 1;
      font-size: 13px;
      color: ${token.colorTextSecondary};
      line-height: 1.6;
    `,

    viewHeaderExtra: css`
      flex-shrink: 0;
    `,

    baseView: css`
      display: flex;
      flex-direction: column;
      gap: ${token.marginXL}px;
    `,

    profileSection: css`
      display: flex;
      align-items: flex-start;
      gap: ${token.marginXL}px;

      @media screen and (max-width: ${token.screenMD}px) {
        flex-direction: column;
        align-items: center;
        gap: ${token.marginLG}px;
      }
    `,

    avatarSection: css`
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: ${token.marginSM}px;
    `,

    avatarWrapper: css`
      position: relative;
      cursor: pointer;
    `,

    avatar: css`
      transition: all 0.3s ease;
    `,

    avatarOverlay: css`
      position: absolute;
      inset: 0;
      border-radius: 50%;
      /* hover 蒙层:语义是"模糊视觉以显示编辑按钮",固定半透明黑底跨主题稳定 */
      background: rgba(0, 0, 0, 0.4);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.3s ease;
      color: ${token.colorTextLightSolid};
      font-size: 14px;
      gap: 4px;
    `,

    avatarIcon: css`
      font-size: 20px;
    `,

    avatarHint: css`
      font-size: 12px;
      color: ${token.colorTextTertiary};
      text-align: center;
      max-width: 120px;
    `,

    formSection: css`
      flex: 1;
      max-width: 720px;

      @media screen and (max-width: ${token.screenMD}px) {
        max-width: 100%;
        width: 100%;
      }
    `,

    sectionTitle: css`
      font-size: 15px;
      font-weight: 600;
      color: ${token.colorTextHeading};
      margin-bottom: ${token.margin}px;
      display: flex;
      align-items: center;
      gap: ${token.marginXS}px;
    `,

    formGrid: css`
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: ${token.marginLG}px;

      @media screen and (max-width: ${token.screenSM}px) {
        grid-template-columns: 1fr;
      }
    `,

    fieldGroup: css`
      display: flex;
      flex-direction: column;
      gap: ${token.marginXXS}px;
    `,

    fieldLabel: css`
      font-size: 12px;
      color: ${token.colorTextTertiary};
    `,

    fieldValue: css`
      font-size: 14px;
      color: ${token.colorText};
      padding: 6px 0;
    `,

    fieldHint: css`
      font-size: 12px;
      color: ${token.colorTextTertiary};
      margin-top: 2px;
    `,

    submitButton: css`
      margin-top: ${token.margin}px;
    `,

    securityList: css`
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 640px;
    `,

    securityItem: css`
      display: flex;
      align-items: center;
      gap: ${token.marginSM}px;
      padding: ${token.padding}px 0;
      /* 用极弱的 colorSplit(比 borderSecondary 更淡)做最低限度分隔;
         极简党觉得还想拆可以把这条注释打开 */
      & + & {
        border-top: 1px solid ${token.colorSplit};
      }
    `,

    securityIcon: css`
      font-size: 18px;
      color: ${token.colorTextSecondary};
    `,

    securityIconPassword: css`
      color: ${token.colorTextSecondary};
    `,

    securityIconEmail: css`
      color: ${token.colorTextSecondary};
    `,

    securityContent: css`
      flex: 1;
      min-width: 0;
    `,

    securityTitle: css`
      font-size: 14px;
      font-weight: 500;
      color: ${token.colorText};
      margin-bottom: 2px;
    `,

    securityDesc: css`
      font-size: 12px;
      color: ${token.colorTextTertiary};
    `,

    securityEmail: css`
      font-weight: 500;
      color: ${token.colorText};
    `,

    securityAction: css`
      flex-shrink: 0;
    `,

    securityButton: css`
      min-width: 56px;
      padding: 0 ${token.paddingSM}px;
      color: ${token.colorTextSecondary};
      background: transparent;
      border-color: ${token.colorBorder};
      box-shadow: none;

      &:hover,
      &:focus-visible {
        color: ${token.colorText};
        background: ${token.colorFillTertiary};
        border-color: ${token.colorBorderSecondary};
      }
    `,

    statusBadge: css`
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 1px 7px;
      border-radius: 999px;
      font-size: 12px;
      line-height: 20px;
      font-weight: 500;
      margin-left: ${token.marginXS}px;
    `,

    statusBound: css`
      color: ${token.colorSuccessText};
      background: color-mix(in srgb, ${token.colorSuccess} 12%, transparent);
      border: 1px solid
        color-mix(in srgb, ${token.colorSuccess} 22%, transparent);
    `,

    statusUnbound: css`
      color: ${token.colorWarningText};
      background: color-mix(in srgb, ${token.colorWarning} 12%, transparent);
      border: 1px solid
        color-mix(in srgb, ${token.colorWarning} 22%, transparent);
    `,

    modalContent: css`
      padding: 8px 0;
    `,

    modalSteps: css`
      margin-bottom: ${token.marginLG}px;
    `,

    modalForm: css`
      .ant-form-item-label > label {
        color: ${token.colorTextSecondary};
      }
    `,

    modalTip: css`
      padding: ${token.paddingSM}px ${token.padding}px;
      background: ${token.colorFillTertiary};
      border-radius: ${token.borderRadius}px;
      margin-bottom: ${token.marginLG}px;
      font-size: 13px;
      color: ${token.colorText};
    `,

    modalSuccessTip: css`
      padding: ${token.paddingSM}px ${token.padding}px;
      background: ${token.colorSuccessBg};
      border-radius: ${token.borderRadius}px;
      margin-bottom: ${token.marginLG}px;
      font-size: 13px;
      color: ${token.colorText};
    `,

    codeInputRow: css`
      display: flex;
      gap: ${token.marginXS}px;
    `,

    codeInput: css`
      flex: 1;
    `,

    codeButton: css`
      flex-shrink: 0;
    `,

    submitButtonModal: css`
      width: 100%;
      margin-top: ${token.margin}px;
    `,

    currentEmailTag: css`
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 4px 10px;
      background: ${token.colorFillTertiary};
      border-radius: ${token.borderRadius}px;
      font-size: 13px;
      color: ${token.colorText};
      margin-bottom: ${token.marginLG}px;
    `,

    area_code: css`
      width: 72px;
    `,

    phone_number: css`
      width: 214px;
    `,
  };
});

export default useStyles;
